import React from "react";

const CallInstantIcon = ({color}) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3392 17.6617L11.3483 17.6681C12.1404 18.1724 13.0808 18.3914 14.0141 18.2889C14.9475 18.1864 15.8179 17.7685 16.4817 17.1043L17.0583 16.5278C17.186 16.4001 17.2874 16.2485 17.3565 16.0816C17.4257 15.9147 17.4613 15.7358 17.4613 15.5552C17.4613 15.3745 17.4257 15.1957 17.3565 15.0288C17.2874 14.8619 17.186 14.7103 17.0583 14.5826L14.6263 12.1525C14.4986 12.0247 14.347 11.9234 14.1801 11.8542C14.0133 11.7851 13.8344 11.7495 13.6538 11.7495C13.4731 11.7495 13.2942 11.7851 13.1274 11.8542C12.9605 11.9234 12.8089 12.0247 12.6812 12.1525C12.4233 12.4103 12.0736 12.5551 11.709 12.5551C11.3444 12.5551 10.9948 12.4103 10.7369 12.1525L6.84842 8.2631C6.59064 8.00525 6.44584 7.65557 6.44584 7.29097C6.44584 6.92637 6.59064 6.5767 6.84842 6.31885C6.97619 6.19116 7.07755 6.03954 7.14671 5.87266C7.21586 5.70578 7.25146 5.5269 7.25146 5.34626C7.25146 5.16562 7.21586 4.98675 7.14671 4.81987C7.07755 4.65299 6.97619 4.50137 6.84842 4.37368L4.41742 1.9436C4.15957 1.68582 3.80989 1.54102 3.44529 1.54102C3.08069 1.54102 2.73102 1.68582 2.47317 1.9436L1.89567 2.52018C1.23162 3.18401 0.813927 4.05452 0.711591 4.98788C0.609256 5.92123 0.828407 6.86157 1.33283 7.65351L1.33833 7.66268C4.00233 11.6042 7.39721 14.9984 11.3392 17.6617Z"
        stroke={color ?? "#009951"}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CallInstantIcon;
